/**
 * Extrae el mensaje de error de una respuesta Axios de forma type-safe.
 * Reemplaza el patron `(error: any) => error.response?.data?.error || fallback`
 * en todos los handlers onError de los hooks.
 */
export const getApiError = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as Record<string, unknown>).response;
    if (response && typeof response === 'object' && 'data' in response) {
      const data = (response as Record<string, unknown>).data;
      if (data && typeof data === 'object') {
        const msg = (data as Record<string, unknown>).error;
        if (typeof msg === 'string' && msg.length > 0) return msg;
        const msg2 = (data as Record<string, unknown>).message;
        if (typeof msg2 === 'string' && msg2.length > 0) return msg2;
      }
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};
